import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import Editor from 'scoreboard/components/rich-text/editor'
import $ from 'jquery'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import permissions from 'scoreboard/components/permissions'
import ImagePicker from 'scoreboard/components/image-picker'
import prepareRichText from 'scoreboard/components/rich-text/prepare-rich-text'
import momentHelper from 'scoreboard/components/moment-helper'
import YouTubeVideo from './you-tube-video'
import template from './welcome-message.hbs'
import formTemplate from './welcome-message-form.hbs'
import displayTemplate from './welcome-message-display.hbs'
import youTubeVideoPanel from './you-tube-video-panel.hbs'
import youTubeDialogTemplate from './you-tube-dialog.hbs'

/**
 * View that renders the Home page's "welcome message" panel. Toggles between
 * view and edit modes.
 */
var WelcomeMessage = Backbone.View.extend({

	events: {
		'click .edit-item': 'edit',
		'click .cancel': 'cancel',
		'click .add-video': 'onAddVideo',
		'click .you-tube-video': 'playVideo'
	},

	initialize: function (opt) {
		this.options = opt || {}
		this._message = opt.message
		this._imageId = opt.imageId
		this._setVideos(opt.youTubeVideos)
		this.youTubeViews = []
	},

	_setVideos(videos) {
		this._videos = _.map(videos, v => {
			v.url = v.id ? `http://www.youtube.com/watch?v=${v.id}` : ''
			return v
		})
		this._videosById = _.keyBy(this._videos, 'id')
	},

	render: function () {
		this.$el.html(template(this.context()))

		this.view()

		return this
	},

	context: function() {
		let lastLogin = _.get(this.options, 'lastLogin')
		let loginMessage
		if (_.isNil(lastLogin)) {
			loginMessage = i18n.get('home.welcome.message.firstLogin')
		} else {
			loginMessage = i18n.get('home.welcome.message.lastLogin',
				momentHelper.formatDateTime(lastLogin))
		}
		return { loginMessage }
	},

	view: function () {
		this._removeFormView()
		this.$('.panel-content').html(displayTemplate({
			message: prepareRichText(this._message),
			imageSrc: ImagePicker.imgSrc(this._imageId),
			videos: this._videos
		}))

		this._toggleButtons(false)
	},

	edit: function () {

		this._toggleButtons(true)
		this._persistedImageId = this._imageId

		this._editor = new Editor({ text: this._message })

		this.$('.panel-content')
			.html(formTemplate())
			.find('.welcome-message-content')
			.append(this._editor.el)

		this._editor.render()

		this.listenToOnce(this._editor, 'load', function () {
			this.$('.rich-text-content').attr('placeholder', i18n.get('home.welcome.typeAWelcomeMessage'))
			this._editor.focus()

			this._toolbar = this._editor.createToolbar()
			this.$('.editor-toolbar').append(this._toolbar.el)
			this._toolbar.render()

			this.listenTo(this._editor, 'change', function (val) {
				this._formView.setDirty()
			}.bind(this))
		}.bind(this))

		this._formView = new FormView({
			el: this.$('form')[0],
			submit: this.save.bind(this)
		})
		this._renderImagePicker()
		this._renderYouTubeList()

		this._formView.start()
	},

	onAddVideo() {
		this.renderYouTubeRow(new YouTubeVideo())
		this._formView.change()
	},

	cancel: function () {
		this._imageId = this._persistedImageId
		this.view()
	},

	save: function () {
		this._message = this._editor.val()

		const videoIds = _.map(this.$('.video-url'), el => {
			return YouTubeVideo.getIdFromUrl($(el).val())
		})

		const data = {
			message: this._message,
			image: this._image,
			deleteImage: this._deleteImage,
			videoIds
		}
		return $.put('api/home/welcome/message', JSON.stringify(data))
		.done(response => {
			this._persistedImageId = this._imageId = response.imageId
			delete this._image

			const videos = _.get(response, 'youTubeVideos', [])
			const invalidVideos = _.filter(videos, {exists:false})
			if (_.isEmpty(invalidVideos)) {
				this._setVideos(response.youTubeVideos)
				this.view() // leave edit mode
			} else {
				const videoIds = _.map(invalidVideos, 'id')
				_.each(this.youTubeViews, v => {
					if (_.includes(videoIds, v.videoId())) {
						v.markInvalid()
					}
				})
				this._formView.start()
			}
		}).fail(xhr => this._formView.start())
	},

	_removeFormView: function () {
		_.invokeMap([ this._formView, this._imagePicker, this._editor], 'remove')
		_.invokeMap(this.youTubeViews, 'remove')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		this._removeFormView()
	},

	_toggleButtons: function (edit) {
		this.$('.save, .cancel').toggleClass('is-not-displayed', !edit)
		this.$('.edit-item').toggleClass('is-not-displayed', edit || !permissions.appAdmin())
		this.$('.no-welcome-message').toggleClass('is-not-displayed', edit || !!this._message || !permissions.appAdmin())
	},

	_renderImagePicker: function () {
		this._imagePicker = new ImagePicker({
			className: 'welcome-image',
			uploadLabelKey: 'home.welcome.uploadLogo',
			deleteLabelKey: 'home.welcome.deleteLogo',
			scrollEl: this.options.scrollEl
		})
		// Insert image-picker before editor so the text
		// can wrap around the image-picker
		this._editor.$el.before(this._imagePicker.el)
		this._imagePicker.render()

		this._imagePicker.on('pick', image => {
			this._image = image
			delete this._imageId
			delete this._deleteImage
			this._formView.change()
		})

		this._imagePicker.on('delete', () => {
			delete this._image
			delete this._imageId
			this._deleteImage = true
			this._formView.change()
		})

		if (this._imageId) {
			this._imagePicker.imageId(this._imageId)
		}

		this.on('resize', () => this._imagePicker.trigger('resize'))
	},

	_renderYouTubeList: function() {
		this.$('.edit-buttons').before(youTubeVideoPanel())
		if (this._videos.length) {
			_.each(this._videos, v => {
				this.renderYouTubeRow(new YouTubeVideo({model: v}))
			})
		} else {
			this.$('.empty-message-container').removeClass('is-not-displayed')
		}
	},

	renderYouTubeRow: function (row) {
		row.on('delete', () =>  {
			this._formView.change()
			let isEmpty = !this.$('.you-tube-url').length
			this.$('.empty-message-container').toggleClass('is-not-displayed', !isEmpty)
		})
		this.youTubeViews.push(row.render())
		this.$('.you-tube').append(row.el)
		this.$('.empty-message-container').addClass('is-not-displayed')
	},

	playVideo: function(e) {
		const videoId = $(e.target).closest('[data-id]').data('id')
		const {aspectRatio} = this._videosById[videoId]
		appDisplay.dialog(new YouTubePlayer({
			videoId,
			videoAspectRatio: aspectRatio
		}))
	}
})

var YouTubePlayer = Backbone.View.extend({
	className: 'you-tube-player',

	initialize: function(opts) {
		this.videoId = opts.videoId
		this.videoAspectRatio = opts.videoAspectRatio
	},

	render: function() {
		const url = YouTubeVideo.buildUrl(this.videoId)
		this.$el.append(youTubeDialogTemplate({url}))
	},

	resize: function() {
		const aspectRatio = this.videoAspectRatio || 1.7778 // 1.7778 = 16:9
		const maxHeight = window.innerHeight * .90
		const width = window.innerWidth * .90
		const height = width / aspectRatio

		const iFrame = this.$('iframe')
		if (height > maxHeight) {
			// #16710 Don't allow iframe to scale out of the window
			// or the close button gets hidden
			iFrame.width(maxHeight * aspectRatio)
			iFrame.height(maxHeight)
		} else {
			iFrame.width(width)
			iFrame.height(height)
		}
	}
})

export default WelcomeMessage

WelcomeMessage.__filename__ = 'home/welcome-message.js'
